
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.602 8.82H.789l2.762-8h2.18l2.757 8H6.676L4.672 2.646h-.063L2.602 8.82zm-.114-3.145H6.77v1.32H2.49v-1.32zM9.452 8.82v-6h1.664v6H9.452zm.836-6.774a.904.904 0 01-.637-.246.798.798 0 01-.261-.598c0-.23.087-.426.261-.59a.896.896 0 01.637-.25c.247 0 .458.083.633.25.177.164.266.36.266.59a.793.793 0 01-.266.598.89.89 0 01-.633.246z","fill":"#F19F39"}})])
          )
        }
      }
    